<template>
  <span class="scaling-svg-container">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14.632"
      height="14.678"
      viewBox="0 0 14.632 14.678"
      class="scaling-svg"
    >
      <path
        d="M2.414,16.056a.438.438,0,0,1-.438-.5l.438-3.124a.438.438,0,0,1,.126-.251L12.012,2.81a2.094,2.094,0,0,1,3.229-.029A2.231,2.231,0,0,1,16,4.367a2.312,2.312,0,0,1-.79,1.626c-.365.359-.862.852-.862.852h0L5.738,15.362a.438.438,0,0,1-.226.118l-3.017.576a.5.5,0,0,1-.08,0ZM3.26,12.7l-.329,2.379,2.287-.43,8.515-8.426.862-.853a1.478,1.478,0,0,0,.53-1,1.392,1.392,0,0,0-.5-.958,1.228,1.228,0,0,0-2,.028ZM14.042,6.53Z"
        transform="translate(-1.671 -1.679)"
        stroke="currentColor"
        stroke-width="0.6"
      />
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class EditIcon extends Vue {}
</script>

<style>
</style>
